import {PaginaLogada} from "../../componentes";
import {useParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {ItemServico} from "../../servicos";
import {
  exibirMensagemErro,
  exibirMensagemSucesso,
  formatarDinheiro,
  HttpVerbo,
  xfetch
} from "../../util";
import {downloadArquivo, upload} from "../../util/xfetch";
import CardPadrao from '../../componentes/card/card-padrao';
import {Anchor, Center, Divider, FileInput, Grid, List, Modal, NumberInput, Select, TextInput} from '@mantine/core';
import {
  COL_RESP_2,
  COL_RESP_3,
  COL_RESP_4,
  COL_RESP_6,
  COR,
  FONTE_FUNDO_A_FUNDO
} from '../../config/constantes/constantes-mantine';
import DinheiroInput from '../../componentes/form/dinheiro-input';
import {Item} from "../../tipos/item";
import {
  BotaoAlterar,
  BotaoAtivarInativar,
  BotaoEnviar,
  BotaoMantine, BotaoUpload
} from "../../componentes/botao/botao-mantine";
import SelectFetchMantine from "../../componentes/form/select-fetch-mantine";
import {dateParser, displayFlagStyle} from "../../util/util";
import {DateInput} from "@mantine/dates";
import {Meta} from "../../tipos/meta";
import {useDisclosure} from "@mantine/hooks";
import {Arquivo} from "../../tipos/arquivo";
import {AcaoEixo} from "../../tipos/acao-eixo";
import {IconBolt} from "@tabler/icons-react";
import {ItemCmd} from "../../tipos/cmd/item-cmd";

export default function ItemDetalhes() {

  const parametros = useParams()
  const idMeta = parametros.idMeta

  const [idAcao, setIdAcao] = useState<number>()
  const [acoes, setAcoes] = useState<AcaoEixo[]>([])

  const [item, setItem] = useState<Item>(new Item())
  const [meta, setMeta] = useState<Meta>()
  const [isCarregando, setIsCarregando] = useState(false)

  const [arquivos, setArquivos] = useState<Arquivo[]>([])
  const [files, setFiles] = useState('')
  const inputUploadArquivosRef = useRef<any>()

  const [arquivosFinanceiros, setArquivosFinanceiros] = useState<Arquivo[]>([])
  const [filesFinanceiro, setFilesFinanceiro] = useState('')
  const inputUploadFinanceirosRef = useRef<any>()

  const [dataExecucao, setDataExecucao] = useState<Date>(new Date())
  const [valorExecutado, setValorExecutado] = useState(0)

  const [modalExecutarItem, {open: openModalExecutarItem, close: closeModalExecutarItem}] = useDisclosure(false);


  const buscarItem = () => {
    setIsCarregando(true)
    ItemServico.getItem(parametros.idItem)
      .then(res => res.json())
      .then(dados => {
        setItem(dados)
        setIdAcao(dados.acaoEixo?.id)
        setArquivos(dados.arquivos)
        setArquivosFinanceiros(dados.arquivosFinanceiros)
        setIsCarregando(false)
      })
      .catch(e => {
        exibirMensagemErro("Erro ao consultar item - " + e)
        setIsCarregando(false)
      })
  }

  const carregaMeta = () => {
    const id = parametros.idMeta
    setIsCarregando(true)
    xfetch('/projeto/meta/' + id, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(json => {
        setMeta(json)
        setIsCarregando(false)
      })
    // .catch(e => setIsCarregando(false) & exibirMensagemErro("Erro ao carregar meta - "+ e))
  }

  function buscarAcoes() {
    setIsCarregando(true)
    xfetch(`/meta/${idMeta}/acao`, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => {
        setAcoes(dados)
      })
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    buscarItem()
    buscarAcoes()
    carregaMeta()
  }, [])

  function uploadFiles() {

    if (files === "") return exibirMensagemErro("Nenhum arquivo foi anexado.")

    let formData = new FormData();

    for (const element of files) {
      formData.append("arquivos", element)
    }
    setFiles('')
    upload('/item/' + item.id.toString() + '/upload', formData)
      .then(res => {
        if (res.status === 200) {
          exibirMensagemSucesso('Upload feito com sucesso')
          buscarItem()
          inputUploadArquivosRef.current = undefined
        }
      })
      .catch(err => {
        exibirMensagemErro('Erro ao fazer upload - ' + err)
      })
  }

  function uploadFilesFinanceiro() {

    if (filesFinanceiro === "") return exibirMensagemErro("Nenhum arquivo foi anexado.")

    let formData = new FormData();

    for (const element of filesFinanceiro) {
      formData.append("arquivos", element)
    }
    setFilesFinanceiro('')
    upload('/item/' + item.id.toString() + '/financeiro/upload', formData)
      .then(res => {
        if (res.status === 200) {
          exibirMensagemSucesso('Upload feito com sucesso')
          buscarItem()
          inputUploadFinanceirosRef.current = ""
        }
      })
      .catch(err => {
        exibirMensagemErro('Erro ao fazer upload - ' + err)
      })
  }

  function limparDadosModal() {
    setDataExecucao(new Date)
    setValorExecutado(0)
  }

  function toggleItem(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault()
    setIsCarregando(true)
    const msg = item.isAtivo ? 'DESATIVAR' : 'ATIVAR'
    const resposta = window.confirm(`Deseja realmente ${msg} esse item?`)
    if (resposta) {
      xfetch(`/item/${item.id}/toggle`, {}, HttpVerbo.POST)
        .then(res => res.json())
        .then(json => {
          buscarItem()
        })
    }
  }

  const changeUploadFinanceiro = (e: any) => {
    setFilesFinanceiro(e)
  }

  const changeUpload = (e: any) => {
    console.log(e)
    setFiles(e)
  }

  const isFundoaFundo = meta?.idFonteRecurso === FONTE_FUNDO_A_FUNDO

  function alterarItem() {
    setIsCarregando(true)
    const dados: ItemCmd = {
      id: item.id,
      idAcao: idAcao,
      nome: item.nome,
      valorExecutado: item.valorExecutado,
      quantidade: item.quantidade,
      valorCotado: item.valorCotado,
      dataExecucao: item.dataExecucao,
      numeroEdoc: item.numeroEmpenho,
      numeroEmpenho: item.numeroEmpenho,
      numeroNotaFiscal: item.numeroNotaFiscal
    }

    validaDados(dados)

    xfetch(`/item/${item.id}/edit`, dados, HttpVerbo.PUT)
      .then(res => res.json())
      .then(dados => {
        exibirMensagemSucesso("Alteracao feita com sucesso")
      })
      .catch((e) => exibirMensagemErro(e.message))
      .finally(() => setIsCarregando(false))
  }

  function validaDados(dados: any) {
    if (!dados.idItem) {
      exibirMensagemErro('Item não identificado.')
      return
    }

    if (!dados.idAcao) {
      exibirMensagemErro('Ação não identificada.')
      return
    }
  }

  const selectAcaoOptions = acoes?.length > 0 ? acoes.map((item: any, k) => {
    return {key: k, value: item.id.toString(), label: item.nome}
  }) : [];

  return (
    <PaginaLogada titulo="Detalhe do item" isCarregando={isCarregando} botaoVoltar
                  voltarPara={`/projeto/${parametros.idProjeto}/meta/${parametros.idMeta}`}>
      <CardPadrao>
        <Grid>
          <Grid.Col span={12}>
            <TextInput
              label={"Nome"}
              value={item.nome}
              onChange={(e) => {
                setItem({...item, nome: e.target.value})
              }}/>
          </Grid.Col>
          <Grid.Col span={12} style={displayFlagStyle(isFundoaFundo)}>
            <Select
              label={"Ação"}
              placeholder={"Selecione a ação"}
              data={selectAcaoOptions}
              value={item.acaoEixo?.id.toString()}
              onChange={(e) => {
                setIdAcao(Number(e))
              }}/>
          </Grid.Col>
          <Grid.Col span={COL_RESP_2}>
            <NumberInput
              hideControls
              label={"Quantidade"}
              value={item.quantidade}
              onChange={(e) => setItem({...item, quantidade: Number(e)})}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2}>
            <DinheiroInput
              label={"Valor Cotado Unitário"}
              value={item.valorCotado}
              onChange={(e) => {
                setItem({...item, valorCotado: Number(e)})
              }}/>
          </Grid.Col>
          <Grid.Col span={COL_RESP_2} style={displayFlagStyle(item.isExecutado)}>
            <DinheiroInput
              label={"Valor Executado Unitário"}
              value={formatarDinheiro(item.valorExecutado)}
              onChange={(e) => {
                setItem({...item, valorExecutado: Number(e)})
              }}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2} style={displayFlagStyle(item.isExecutado)}>
            <DateInput
              placeholder="DD/MM/AAAA"
              valueFormat="DD/MM/YYYY"
              label={"Data de Execução"}
              clearable
              value={dateParser(item.dataExecucao)}
              onChange={(e) => setItem({...item, dataExecucao: new Date(e!!)})}

            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2}>
            <TextInput
              label={"Número Empenho"}
              value={item.numeroEmpenho}
              onChange={(e) => {
                setItem({...item, numeroEmpenho: e.target.value})
              }}/>
          </Grid.Col>
          <Grid.Col span={COL_RESP_4}>
            <TextInput
              label={"Número Nota Fiscal"}
              value={item.numeroNotaFiscal}
              onChange={(e) => {
                setItem({...item, numeroNotaFiscal: e.target.value})
              }}/>
          </Grid.Col>
          <Grid.Col span={COL_RESP_2} style={{alignSelf: "self-end"}}>
            <Center>
              <BotaoAlterar onClick={alterarItem}/>
            </Center>
          </Grid.Col>
        </Grid>
        <Grid style={displayFlagStyle(!isFundoaFundo)}>
          <Grid.Col span={COL_RESP_3}>
            <SelectFetchMantine
              label={"Natureza Despesa"}
              url='/naturezaDespesa'
              placeholder='Selecione a natureza'
              onChange={(e) => console.log(e)}/>
          </Grid.Col>
          <Grid.Col span={COL_RESP_3}>
            <TextInput
              label={"Número E-DOC"}
              value={item.numeroEdoc}
              onChange={(e) => {
                setItem({...item, numeroEdoc: e.target.value})
              }}/>
          </Grid.Col>
          <Grid.Col span={COL_RESP_4} style={displayFlagStyle(!item.isExecutado)} className={"alinhar-abaixo"}>
            <BotaoAtivarInativar flag={item.isAtivo} onClick={toggleItem} m={5}/>
            <BotaoMantine icone={IconBolt} color={COR.ALERTA} onClick={openModalExecutarItem}
                          m={5}>Executar</BotaoMantine>
          </Grid.Col>
        </Grid>
      </CardPadrao>

      <Grid mt={40}>
        <Grid.Col span={COL_RESP_6}>
          <CardPadrao titulo="Arquivos">
            <FileInput
              multiple
              ref={inputUploadArquivosRef}
              description={"Insira os arquivos e em seguida clique no botão upload"}
              placeholder={"Clique aqui para selecionar os arquivos"}
              onChange={changeUpload}
              rightSection={<BotaoUpload onClick={uploadFiles} disabled={files === ''}/>}
              rightSectionWidth={"auto"}/>

            <Divider mt={30} mb={20}/>

            <List>
              {arquivos.map((v, k) => {
                return (
                  <List.Item key={k}>
                    <Anchor href="#"
                            onClick={() => downloadArquivo('/download/' + v.uuid, v.nome)}>
                      {v.nome}
                    </Anchor>
                  </List.Item>
                )
              })}
            </List>
          </CardPadrao>
        </Grid.Col>
        <Grid.Col span={COL_RESP_6}>
          <CardPadrao titulo="Arquivos Financeiros">
            <FileInput
              multiple
              clearable
              ref={inputUploadFinanceirosRef}
              description={"Insira os arquivos e em seguida clique no botão upload"}
              placeholder={"Clique aqui para selecionar os arquivos"}
              onChange={changeUploadFinanceiro}
              rightSection={<BotaoUpload onClick={uploadFilesFinanceiro} disabled={filesFinanceiro === ''}/>}
              rightSectionWidth={"auto"}/>

            <Divider mt={30} mb={20}/>

            <List>
              {arquivosFinanceiros.map((v, k) => {
                return (
                  <List.Item key={k}>
                    <Anchor href="#"
                            onClick={() => downloadArquivo('/download/' + v.uuid, v.nome)}>
                      {v.nome}
                    </Anchor>
                  </List.Item>
                )
              })}
            </List>
          </CardPadrao>
        </Grid.Col>
      </Grid>
      {modalExecutar()}
    </PaginaLogada>
  )


  function enviarExecucao(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault()
    console.log(valorExecutado)
    console.log(dataExecucao)

    if (!dataExecucao || !valorExecutado) {
      exibirMensagemErro('Preencha os dados de execução')
      return
    }

    const dados = {
      dataExecucao: dataExecucao,
      valorExecucao: valorExecutado
    }
    setIsCarregando(true)
    xfetch(`/item/${item.id}/executar`, dados, HttpVerbo.POST)
      .then(res => res.json())
      .then(json => {
        exibirMensagemSucesso('Item executado com sucesso')
        setIsCarregando(false)
        closeModalExecutarItem()
        limparDadosModal()
        buscarItem()
      })
      .finally(() => setIsCarregando(false))
  }

  function modalExecutar() {
    return (
      <Modal opened={modalExecutarItem} onClose={closeModalExecutarItem} title={item.nome} size="lg">
        <Grid>
          <Grid.Col span={12}>
            <DinheiroInput
              label={"Valor Executado Unitário"}
              value={valorExecutado}
              onChange={(e) => {
                setValorExecutado(Number(e))
              }}/>
          </Grid.Col>
          <Grid.Col span={12}>
            <DateInput
              placeholder="DD/MM/AAAA"
              valueFormat="DD/MM/YYYY"
              label={"Data Execução"}
              clearable
              value={dataExecucao}
              onChange={(e) => setDataExecucao(new Date(e!!))}/>
          </Grid.Col>
          <Grid.Col span={12}>
            <BotaoEnviar onClick={enviarExecucao}>Enviar</BotaoEnviar>
          </Grid.Col>
        </Grid>
      </Modal>
    );
  }
}
